import AsoHeader from '../../../components/Aso/Header';
import AsoValidarInfoTrabalhadorExistente from "../../../components/Aso/Register/AsoValidarInfoTrabalhadorExistente";

export function AsoRegistroValidarInfoTrabalhadorExistente() {

  return (
    <div>
      <AsoHeader />
      <AsoValidarInfoTrabalhadorExistente />
    </div>
  );
}
